/* eslint-disable import/prefer-default-export */

import {
  ACCEPT_INVITATION_FAILURE,
  ACCEPT_INVITATION_SUCCESS,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_SUCCESS_RESET,
  DEACTIVATE_USER_SUCCESS,
  FETCH_USER_DETAILS_FAILURE,
  FETCH_USER_DETAILS_SUCCESS,
  GET_DEACTIVATED_USERS_FAILURE,
  GET_DEACTIVATED_USERS_SUCCESS,
  GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_USERS_FOR_LOGISTICS_PARTY_FAILURE,
  GET_USERS_FOR_LOGISTICS_PARTY_REQUEST,
  GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS,
  GET_USER_PROFILE_INFO_ACTIONS_SUCCESS,
  UPDATE_USER_LOCALE_SUCCESS,
  UPDATE_USER_PROFILE_INFO_SUCCESS,
} from '../../actions/userManagementActions/actionTypes';

export const initialState = {
  user: {},
  invitationStatus: {
    status: '',
    error: false,
  },
  requestedUserProfileDetails: {},
  usersList: [],
  usersListError: false,
  invitationsList: [],
  createInvitationSuccess: false,
  deactivatedUsersList: null,
};

export function userManagementReducer(
  state = initialState,
  { type, payload }: { type: string; payload: any }
) {
  switch (type) {
    case GET_USER_PROFILE_INFO_ACTIONS_SUCCESS: {
      return {
        ...state,
        user: payload.user,
      };
    }
    case UPDATE_USER_PROFILE_INFO_SUCCESS:
    case UPDATE_USER_LOCALE_SUCCESS: {
      return {
        ...state,
        user: payload,
      };
    }
    case ACCEPT_INVITATION_SUCCESS: {
      return {
        ...state,
        invitationStatus: {
          status: payload,
          error: false,
        },
      };
    }
    case ACCEPT_INVITATION_FAILURE: {
      return {
        ...state,
        invitationStatus: {
          status: '',
          error: true,
        },
      };
    }

    case GET_USERS_FOR_LOGISTICS_PARTY_REQUEST: {
      return {
        ...state,
        usersListError: false,
      };
    }

    case GET_USERS_FOR_LOGISTICS_PARTY_SUCCESS: {
      return {
        ...state,
        usersList: payload || [],
      };
    }

    case GET_USERS_FOR_LOGISTICS_PARTY_FAILURE: {
      return {
        ...state,
        usersListError: true,
      };
    }

    case GET_INVITED_USERS_FOR_LOGISTICS_PARTY_SUCCESS: {
      return {
        ...state,
        invitationsList: payload?.length
          ? payload.map((invitation: any) => ({
              ...invitation,
              inviteeEmail:
                invitation?.invitationChannelInfo?.inviteeEmail ?? '',
            }))
          : [],
      };
    }

    case CREATE_INVITATION_SUCCESS: {
      return {
        ...state,
        createInvitationSuccess: true,
      };
    }

    case CREATE_INVITATION_SUCCESS_RESET: {
      return {
        ...state,
        createInvitationSuccess: false,
      };
    }
    case DEACTIVATE_USER_SUCCESS: {
      return {
        ...state,
        deactivatedUsersList: null,
        usersList: null,
      };
    }
    case GET_DEACTIVATED_USERS_SUCCESS: {
      return {
        ...state,
        deactivatedUsersList: payload.userList,
      };
    }
    case GET_DEACTIVATED_USERS_FAILURE: {
      return {
        ...state,
        deactivatedUsersList: undefined,
      };
    }
    case FETCH_USER_DETAILS_SUCCESS: {
      const { requestedUserId, requestedUserDetails } = payload;
      return {
        ...state,
        requestedUserProfileDetails: {
          ...state.requestedUserProfileDetails,
          [requestedUserId]: requestedUserDetails,
        },
      };
    }

    case FETCH_USER_DETAILS_FAILURE: {
      const { requestedUserId } = payload;
      return {
        ...state,
        requestedUserProfileDetails: {
          ...state.requestedUserProfileDetails,
          [requestedUserId]: {},
        },
      };
    }

    default: {
      return state;
    }
  }
}
